import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const FlagCambioAnoFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagCambioAno'>
      {({ field }) => (
        <Form.Checkbox
          {...field}
          checked={iValue}
          disabled={fIsSubmitting}
          id='checkbox-flagCambioAno'
          label='Cambio de año'
        />
      )}
    </Field>
  )
}

export default React.memo(FlagCambioAnoFormGroup)
